"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var react_intl_1=require("react-intl"),getTranslation=function(e,t){return(0,react_intl_1.useIntl)().formatMessage({id:e},t)};
/**
 * Translate a given index to the correct language<br/>
 * NOTE: This does not rerender automatically. Trigger a rerender manually to get the string
 * @function
 * @param {string} id String index to be translated
 * @param {object} [value] Object containing indexes and values to be matched with wildcards
 * @returns {string} Translated message
 * @copyright Spordle
 * @example
 * getTranslation('settings.label.edit')
 * getTranslation(`settings.error.${formik.status}`)
 * getTranslation("misc.priceValue" ,{price: tournament.price}
 */exports.default=getTranslation;